/* ==========================================================================
   BD Predictive Search — fetch + render
   File: assets/predictive-search.js
   Confirmed response shape (Shopify Predictive Search API):
   { resources: { results: { products: [
       { title, url, image, price, price_min, price_max,
         compare_at_price_min, compare_at_price_max, available, ... }
   ] } } }
   Note: price / compare_at_price_* are plain decimal strings
   (e.g. "2299.00"), NOT pre-formatted with a currency symbol.
   ========================================================================== */

(function () {
  'use strict';

  var DEBOUNCE_MS = 300;
  var MIN_CHARS = 2;

  var input = document.querySelector('[data-predictive-search-input]');
  var resultsBox = document.getElementById('predictive-search-results');
  if (!input || !resultsBox) return;

  var debounceTimer = null;
  var activeController = null;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  function formatMoney(priceStr) {
    var num = parseFloat(priceStr);
    if (isNaN(num)) return '';
    return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function open() {
    resultsBox.classList.add('is-open');
    input.setAttribute('aria-expanded', 'true');
  }
  function close() {
    resultsBox.classList.remove('is-open');
    input.setAttribute('aria-expanded', 'false');
  }

  function renderLoading() {
    resultsBox.innerHTML = '<div class="bd-predictive-loading">Searching…</div>';
    open();
  }

  function renderEmpty(query) {
    resultsBox.innerHTML = '<div class="bd-predictive-empty">No products found for "' + escapeHtml(query) + '"</div>';
    open();
  }

  function renderResults(products, query) {
    var html = '<ul class="bd-predictive-list" role="listbox">';

    products.forEach(function (p) {
      var currentPrice = p.price_min || p.price;
      var hasSale = p.compare_at_price_min && parseFloat(p.compare_at_price_min) > parseFloat(currentPrice);

      var priceHtml = '<span class="bd-predictive-item-price">' + formatMoney(currentPrice) + '</span>';
      if (hasSale) {
        priceHtml += '<span class="bd-predictive-item-compare">' + formatMoney(p.compare_at_price_min) + '</span>';
      }

      var imgHtml = p.image
        ? '<img src="' + p.image + '&width=100" alt="" width="50" height="63" loading="lazy">'
        : '<div class="bd-predictive-item-placeholder"></div>';

      html +=
        '<li>' +
          '<a href="' + p.url + '" class="bd-predictive-item">' +
            imgHtml +
            '<span class="bd-predictive-item-info">' +
              '<span class="bd-predictive-item-title">' + escapeHtml(p.title) + '</span>' +
              priceHtml +
            '</span>' +
          '</a>' +
        '</li>';
    });

    html += '</ul>';
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="bd-predictive-viewall">View all results for "' + escapeHtml(query) + '" &rarr;</a>';

    resultsBox.innerHTML = html;
    open();
  }

  function search(query) {
    if (activeController) activeController.abort();
    activeController = new AbortController();

    renderLoading();

    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
      { signal: activeController.signal }
    )
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          renderEmpty(query);
        } else {
          renderResults(products, query);
        }
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          resultsBox.innerHTML = '<div class="bd-predictive-empty">Something went wrong. Please try again.</div>';
          open();
        }
      });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < MIN_CHARS) {
      close();
      return;
    }

    debounceTimer = setTimeout(function () {
      search(query);
    }, DEBOUNCE_MS);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MIN_CHARS && resultsBox.innerHTML.trim() !== '') {
      open();
    }
  });

  document.addEventListener('click', function (e) {
    if (!resultsBox.contains(e.target) && e.target !== input) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();